import { render, staticRenderFns } from "./NewsListing.vue?vue&type=template&id=269ad45f&scoped=true&"
import script from "./NewsListing.vue?vue&type=script&lang=js&"
export * from "./NewsListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269ad45f",
  null
  
)

export default component.exports